var map = {
	"./de-DE": 141,
	"./de-DE.js": 141,
	"./en-US": 37245,
	"./en-US.js": 37245,
	"./es-ES": 89040,
	"./es-ES.js": 89040,
	"./fr-FR": 36598,
	"./fr-FR.js": 36598,
	"./it-IT": 13940,
	"./it-IT.js": 13940,
	"./ja-JP": 51337,
	"./ja-JP.js": 51337,
	"./ko-KR": 81141,
	"./ko-KR.js": 81141,
	"./pt-BR": 34150,
	"./pt-BR.js": 34150,
	"./ru-RU": 80154,
	"./ru-RU.js": 80154,
	"./tr-TR": 75989,
	"./tr-TR.js": 75989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38681;